import ARGENTINA from '@tectonics/commons/country/countries/argentina';
import BRAZIL from '@tectonics/commons/country/countries/brazil';
import CHILE from '@tectonics/commons/country/countries/chile';
import COLOMBIA from '@tectonics/commons/country/countries/colombia';
import GUATEMALA from '@tectonics/commons/country/countries/guatemala';
import INDONESIA from '@tectonics/commons/country/countries/indonesia';
import THAILAND from '@tectonics/commons/country/countries/thailand';
import TURKEY from '@tectonics/commons/country/countries/turkey';
import MALAYSIA from '@tectonics/commons/country/countries/malaysia';
import { COUNTRY_ABBREVIATIONS } from '@tectonics/prs/country';
import type { Country as CountryCode } from '@tectonics/prs/country';
import type { PaymentMethod } from '@tectonics/commons/new-payment-methods/payment-method';
import type { CustomerForm } from '@tectonics/commons/customer-form/types';
import type { OutgoingPaymentMapper } from '@tectonics/prs/outgoing-payment/mapper/types';
import { createDefaultCountry } from './default-country';

export interface TaxDisplayConfig {
  taxCode: string;
  percentage: string;
  label: string;
  tooltipLabel: string;
  tooltipTextKey: string;
  testId: string;
}

export interface Country {
  code: CountryCode;
  termsAndConditionsUrl?: string;
  privacyPolicyUrl?: string;
  supportedPaymentMethods?: Array<PaymentMethod>;
  outgoingPaymentMapper?: OutgoingPaymentMapper;
  customerForm: CustomerForm;
  taxDisplay?: TaxDisplayConfig;
}

const CUSTOMIZED_COUNTRIES: Array<Country> = [ARGENTINA, BRAZIL, CHILE, COLOMBIA, GUATEMALA, INDONESIA, THAILAND, TURKEY, MALAYSIA];

export const SUPPORTED_COUNTRIES: Array<Country> = COUNTRY_ABBREVIATIONS.map((code) => {
  return CUSTOMIZED_COUNTRIES.find((country) => country.code === code) ?? createDefaultCountry(code);
});

export function getCountryFromCode(countryCode: string): Country | undefined {
  return SUPPORTED_COUNTRIES.find((country: Country) => {
    return country.code === countryCode;
  });
}

export function getSafeCountryFromCode(countryCode: string): Country {
  const country = SUPPORTED_COUNTRIES.find((country: Country) => {
    return country.code === countryCode;
  });

  if (!country) {
    throw new Error(`Unsupported country "${countryCode}"`);
  }

  return country;
}
